import type { InferGetServerSidePropsType } from 'next'
import Head from 'next/head'
import React from 'react'
import { combineUrl } from '../../app/data/combineUrl'
import type { FontResult } from '../../app/data/content/FontFragment'
import { FontsFragment } from '../../app/data/content/FontsFragment'
import { FooterMenuFragment } from '../../app/data/content/FooterMenuFragment'
import { MenuFragment } from '../../app/data/content/MenuFragment'
import { ProductFragment, ProductResult } from '../../app/data/content/ProductFragment'
import { Fonts } from '../../components/Fonts'
import { Footer } from '../../components/Footer'
import { Nav } from '../../components/Nav'
import { NavCart } from '../../components/NavCart'
import { ProductList } from '../../components/Products'
import { Seo } from '../../components/Seo'
import { SimpleHeader } from '../../components/SimpleHeader'
import { One, Thunder } from '../../generated/content'
import { serverPropsHandler } from '../../packages/@necktip/next/api/handlers'
import { getZeusConnection } from '../../packages/@necktip/next/loaders/graphql'

export type CommonPageProps = InferGetServerSidePropsType<typeof getServerSideProps>

export default function CommonPage(props: CommonPageProps) {
	const data = props.dataFromContember
	const products = data.listProduct as Array<ProductResult>
	const fonts = data.listFont as Array<FontResult>

	return (
		<div>
			<Head>
				<title>Naše neony - Neon Hort</title>
			</Head>
			<Seo title="Naše produkty - Neon Hort" />
			<Fonts fonts={fonts} />
			<Nav items={data.getMenu?.localesByLocale} className="filled" />
			<NavCart />
			<div className="content">
				<SimpleHeader
					headline="Naše neony"
					desc="Tady najdete veškeré neony, které máme momentálně v nabídce. Pokud si nevyberete a chtěli byste něco specíálního, koukněte na náš konfigurátor a udělejte si neon podle vašich představ."
					className="spaceBottom"
				/>
				<ProductList products={products} />
			</div>
			<Footer
				items={data.getMenu?.localesByLocale}
				footerItems={data.getFooterMenu?.localesByLocale}
			/>
		</div>
	)
}

export const getServerSideProps = serverPropsHandler(async (context) => {
	const content = getZeusConnection(Thunder, 'content')
	const urlInfo = combineUrl(context, false, 'blog')
	const locale = urlInfo.locale
	const url = `${urlInfo.path}`

	const dataFromContember = await content.query({
		listProduct: [
			{
				filter: {
					isCustomProduct: { or: [{ isNull: true }, { eq: false }] },
				},
			},
			ProductFragment(locale),
		],
		getFooterMenu: [{ by: { unique: One.One } }, FooterMenuFragment(locale)],
		getMenu: [{ by: { unique: One.One } }, MenuFragment(locale)],
		listFont: [{}, FontsFragment()],
	})

	return {
		props: {
			url,
			urlInfo,
			dataFromContember,
			serverTime: new Date().toString(),
		},
	}
})
